import Clock from '@crehana/compass.icons.outline/Clock';
import Eye from '@crehana/compass.icons.outline/Eye';
export var getTagLabel = function getTagLabel(_ref) {
  var type = _ref.type;
  switch (type) {
    case 'temporal-access':
      return 'acceso temporal';
    // 'freemium'
    default:
      return 'acceso gratuito';
  }
};
export var getTagIcon = function getTagIcon(_ref2) {
  var type = _ref2.type,
    icon = _ref2.icon,
    label = _ref2.label;
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (label && !icon) return;

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (label && icon) return icon;

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (type === 'freemium') return Eye;

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (type === 'temporal-access') return Clock;
};